import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminService } from '../../../../admin.service';
import { SnackService } from '@shared/services/snack.service';
import { GlossaryService } from '@shared/services/glossary.service';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-glossary-create',
    templateUrl: './admin-glossary-create.component.html',
    styleUrls: ['./admin-glossary-create.component.scss'],
    standalone: false
})
export class AdminGlossaryCreateComponent extends AdminActionsDirective {
    formGroup: UntypedFormGroup;

    constructor(
        private glossaryService: GlossaryService,
        private fb: UntypedFormBuilder,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
        this.buildForm();
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            title: [null, Validators.required],
            description: [null, Validators.required],
            titleDe: null,
            descriptionDe: null
        });
    }

    async createItem(event: any): Promise<void> {
        this.disableSubmitter(event);
        if (this.formGroup.valid) {
            try {
                const result = await this.glossaryService.createItem(this.formGroup.value);
                this.snack.openSnackBarSuccess(`Glossary item ${result.title} created successfully.`);
                this.goToGlossary();
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }
        this.enableSubmitter(event);
    }
}
